export const audit_stmt = [
  {
    id: "1",
    head: "2023-2024",
    house: "left",
    pdf: "https://drive.google.com/file/d/1krgqqxibEJZmaoIJ6J7Oirl7T6_LKn1e/view?usp=sharing",
  },
  {
    id: "2",
    head: "2022-2023",
    house: "right",
    pdf: "https://drive.google.com/file/d/1GqUVX3ecpx_ZLZpTyhYtulCX0zWxuqjO/view?usp=sharing",
  },
  {
    id: "3",
    head: "2021-2022",
    house: "left",
    pdf: "https://drive.google.com/file/d/1Ggm8mRvSuUHSruJek2aE3sbJqv5VIDVl/view?usp=drive_link",
  },
  {
    id: "3",
    head: "2020-2021",
    house: "right",
    pdf: "https://drive.google.com/file/d/1gEpJOwVPvfbfTxpRC5yAauwJkEpl_OOJ/view?usp=sharing",
  },
];